// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"931":"532e3ec8","973":"c89db15c"}[chunkId] + ".js";
};